import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'FilterTimeValidation';

class FilterTimeValidation extends BaseComponent {
	constructor(element) {
		super(element);
		this._element = element;
		this.fromField = SelectorEngine.findOne('.js-time-validation-from select', this._element);
		this.toField = SelectorEngine.findOne('.js-time-validation-to select', this._element);
		this.errorWrapper = SelectorEngine.findOne('.lta-accordion--panel', this._element);
		this.form = this._element.closest('form');
		this.submitBtn = SelectorEngine.findOne('button[type="submit"]', this.form);
		this.error = undefined;
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this.error = document.createElement('DIV');
		this.error.textContent = 'Please choose a valid time range';
		this.error.classList.add('js-time-validation-message');
		this.error.setAttribute('tabindex', 0);

		this.errorWrapper.append(this.error);
		const handleComparison = () => {
			let toValue = this.toField.options[this.toField.selectedIndex] ? this.toField.options[this.toField.selectedIndex].value : undefined,
				fromValue = this.fromField.options[this.fromField.selectedIndex] ? this.fromField.options[this.fromField.selectedIndex].value : undefined;

			if (!toValue) return;

			toValue = toValue ? parseInt(toValue.split(':')[0]) : parseInt('-1');

			fromValue = fromValue ? parseInt(fromValue.split(':')[0]) : 100;

			if (fromValue >= toValue && toValue != 0) {
				this._element.classList.add('js-time-validation-error');
				setTimeout( () => this.error.focus(), 200);
			} else {
				this._element.classList.remove('js-time-validation-error');
			}
		};

		EventHandler.on(this.fromField, 'change', handleComparison);
		EventHandler.on(this.toField, 'change', handleComparison);
	}
}

export default FilterTimeValidation;
